// extracted by mini-css-extract-plugin
export default {"banner":"StacksBanner_banner__BosJU","primaryAsset":"StacksBanner_primaryAsset__tuZju"};